import { all, spawn } from 'redux-saga/effects'

import bookingSaga from './bookingStore/booking/bookingSaga'
import BookingDetailSaga from './bookingStore/bookingDetail/bookingDetailSaga'
import catalogoListaSeleccion from './catalogos/CatalogoListaSeleccionSagas'
import CatalogosSaga from './catalogos/CatalogosSaga'
import deckplanSaga from './deckplan/deckplanSaga'
import LayoutSaga from './layout/LayoutSaga'
import actividadReservaSagas from './reservasStore/actividadesReservas/actividadesReservasSagas'
import actividadReservaDetalleSaga from './reservasStore/actividadReservaDetalles/actividadReservaDetallesSaga'
import reservasOperacionesSagas from './reservasStore/reservas/reservasOperacionesSagas'
import reservasActionsSagas from './reservasStore/reservasActions/reservasActionsSagas'
import reservasDetallesSaga from './reservasStore/reservasDetalles/reservasDetallesSagas'
import reservasHistoricoSaga from './reservasStore/reservasHistorico/ReservasHistoricoSagas'

// spawn y no fork: con fork un error no atrapado en cualquier saga hija sube hasta esta raíz y
// aborta el árbol completo, dejando la sesión sin ninguna saga viva hasta un F5. Con spawn cada
// rama queda desacoplada y el error se reporta por el onError del middleware (ver store.ts).
export default function* rootSaga(): Generator {
  yield all([
    spawn(LayoutSaga),
    spawn(BookingDetailSaga),
    spawn(actividadReservaSagas),
    spawn(actividadReservaDetalleSaga),
    spawn(reservasOperacionesSagas),
    spawn(reservasDetallesSaga),
    spawn(reservasActionsSagas),
    spawn(CatalogosSaga),
    spawn(deckplanSaga),
    spawn(bookingSaga),
    spawn(reservasHistoricoSaga),
    spawn(catalogoListaSeleccion),
  ])
}
